import Item from '@/store/models/user/Item'

export default {
  setUserBalance(state, val) {
    if (!state.session) return
    state.session.balance = val
  },
  setUserProp(state, [prop, val]) {
    if (!state.session || !prop) return
    state.session[prop] = val
  },
  incUserProp(state, [prop, val]) {
    if (!state.session || !prop) return
    state.session[prop] += val
  },
  addOrRemoveBalance(state, val) {
    if (!state.session) return
    state.session.balance += val
  },
  // connections
  setConnections(state, connections) {
    state.session.connections = connections
  },
  addConnection(state, connection) {
    state.session.connections.push(connection)
  },
  removeConnection(state, provider) {
    const index = state.session.connections.findIndex(i => i.type === provider)

    if (index !== -1) {
      state.session.connections.splice(index, 1)
    }
  },
  // inventory
  selectItem(state, [id, val = true]) {
    const index = state.inventory.findIndex(i => i.id === id)

    if (index !== -1) {
      state.inventory[index].selected = val

      if (state.inventory[index].isNew) {
        state.inventory[index].isNew = false
      }
    }
  },
  selectItems(state, [ids, val]) {
    const items = [...state.inventory].map(item => new Item(({
      ...item,
      isNew: false,
      selected: ids.includes(item.id) ? val : item.selected,
    })))

    state.inventory = items
  },
  addItems(state, items) {
    const { inventory } = state

    // remove dupes
    const invIds = inventory.map(i => i.id)
    const filtered = items.filter(item => !invIds.includes(item.id))

    state.inventory.push(...filtered)
  },
  removeItems(state, ids) {
    const inventory = [...state.inventory]

    for (const id of ids) {
      const index = inventory.findIndex(i => i.id === id)

      if (index !== -1) {
        inventory.splice(index, 1)
      }
    }

    state.inventory = inventory
  },
  setItemsStockInfo(state, items) {
    const inventory = [...state.inventory]

    for (const { id, inStock } of items) {
      const index = inventory.findIndex(i => i.id === id)

      if (index !== -1) {
        inventory[index].inStock = inStock
      }
    }

    state.inventory = inventory
  },
  addRewards(state, rewards) {
    state.rewards.push(...rewards)
  },
  removeReward(state, id) {
    if (!state.rewards.length) return

    const index = state.rewards.findIndex(i => i._id === id)

    if (index !== -1) {
      state.rewards.splice(index, 1)
    }
  },
}
